export default function userMustBeDomainAdmin ({ to, next, store }) {
    if (!store.getters['UserStore/GetTrainingUpToDate'] && to.path !== '/') {
        return next({
            name: 'Dashboard'
        })
    }

    return next()
}